export default __webpack_public_path__ + "static/media/roadmap_4.8aa8ecdb.jpg";